import React from "react";
import clsx from "clsx";
import loadable from "@loadable/component";
import useSystemLinks from "@micado-digital/react-ui/hooks/useSystemLinks";
import useLocals from "@micado-digital/react-ui/hooks/useLocals";
import localDE from "@localDE";
import localEN from "@localEN";

import styles from "./Logo.styles";

const ReactLink = loadable(() => import("@micado-digital/react-link/ReactLink"));
const ReactSVGIcon = loadable(() => import("@micado-digital/react-svg-icon/ReactSVGIcon"));

const Logo = ({ lang }) => {
	const { REACT_APP_PATH } = process.env;
	const sysLink = useSystemLinks();
	const l = useLocals({
		lang: lang,
		res: {
			de: localDE,
			en: localEN
		}
	});
	const css = styles();

	return (
		<ReactLink
			aria-label="klimaneutrale-website"
			className={clsx("mco-view-component-footer__logo-climate-neutral", css.logo)}
			to={REACT_APP_PATH + sysLink("climate-neutral")}
		>
			<p>{l("footer.climateNeutral")}</p>
			<ReactSVGIcon src="/img/logos/climate-neutral.svg" size={112} />
		</ReactLink>
	);
};

export default Logo;
